import { createTheme } from "@mui/material";
export const primaryTheme = createTheme({
  palette: {
    primary: {
      // main: '#333333',
      main: '#d95137',
    },
    secondary: {
      main: '#747373',
    },
  },
});